/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.19.1-30-g35acb1d6-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AddSshKnownHostRequest interface.
 */
export function instanceOfAddSshKnownHostRequest(value) {
    if (!('host' in value) || value['host'] === undefined)
        return false;
    if (!('port' in value) || value['port'] === undefined)
        return false;
    if (!('keyType' in value) || value['keyType'] === undefined)
        return false;
    if (!('keyBase64' in value) || value['keyBase64'] === undefined)
        return false;
    return true;
}
export function AddSshKnownHostRequestFromJSON(json) {
    return AddSshKnownHostRequestFromJSONTyped(json, false);
}
export function AddSshKnownHostRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'host': json['host'],
        'port': json['port'],
        'keyType': json['key_type'],
        'keyBase64': json['key_base64'],
    };
}
export function AddSshKnownHostRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'host': value['host'],
        'port': value['port'],
        'key_type': value['keyType'],
        'key_base64': value['keyBase64'],
    };
}
